<div style="text-align: center; padding: 10%;">
    <img src="/assets/logo_claim.svg" alt="image" >
    <h1 style="font-size: 60px; font-weight: 400; line-height: 1.2em; color: #636362; margin-top: -2em;">Charging Station Calculation (CSC)</h1>
<div>
